<template>
    <el-dialog
            append-to-body
            width="800px"
            :visible.sync="visible"
            title="选择用户"
            @closed="dialogCloseHandler"
            @submit.native.prevent
            custom-class="projects-container">
        <ListLayout>
            <el-form slot="search" :ref="queryFormRef"  inline class="search-form" :model="queryFormData"
                     label-width="70px"
                     @submit.native.prevent>
                <el-form-item label="用户名字" prop="title">
                    <el-input type="text" v-model="queryFormData.name"
                              placeholder="填写用户名字进行搜索"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="queryHandler">查询</el-button>
                    <el-button type="info" @click="resetQueryForms">重置</el-button>
                </el-form-item>
            </el-form>

            <el-table :ref="tableRef" :data="page.list" style="height: 400px;" 
            row-key="id"
            @select="handleSelectionChange"
            @select-all="handleAllChange"
                     >
                <el-table-column
                        type="selection"
                        :reserve-selection="true"
                        width="55">
                </el-table-column>
                <el-table-column type="index" width="50px"></el-table-column>
                <el-table-column label="用户名" show-overflow-tooltip prop="name"></el-table-column>
                <el-table-column label="部门名称" show-overflow-tooltip prop="deptName"></el-table-column>
                <el-table-column label="职务名称" show-overflow-tooltip prop="jobName"></el-table-column>
                <el-table-column label="工作手机" show-overflow-tooltip prop="workTelnum"></el-table-column>
                <el-table-column label="公司名称" show-overflow-tooltip prop="corpName"></el-table-column>
            </el-table>
        </ListLayout>

        <div slot="footer" class="footer-wrap clearFloat">
            <div style="display: flex;flex-direction: row;justify-content: space-between">
                <el-pagination slot="page" background layout="total, prev, pager, next" :total="page.total"
                               :page-size="page.pageSize"
                               style="text-align: left"
                               :current-page.sync="page.pageNum"
                               @current-change="pageNoToggleHandler"
                               @size-change="pageSizeToggleHandler"></el-pagination>
                <div >
                    <span>已选择<strong>{{echoList.length}}</strong>个</span>
                    <el-button class="button-wide" type="danger" @click="addParam">添加</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default JBoot({
        props: {
        },

        data() {
            return {
                moduleName: 'sysRepairPersonnel',
                listMethod: 'queryByPages',
                tableRef: 'pageTableRef',
                resourceList: [],
                selectionRowMap: {},
                visible: false,
                props: {
                    label: 'name',
                    children: 'zones'
                },
                loadNode: {},
    
                echoList: [],// 人员选中的所有id
                echoListName: [],// 人员选中的所有名字
                echoListdeptName:[],
                echoListworkTelnum:[],


            }
        },

        computed: {
            selectionNums() {
                return Object.keys(this.selectionRowMap).reduce((result, key) => {
                    return result + (this.selectionRowMap[key] || []).length;
                }, 0);
            },

            submitParams() {
                return Object.keys(this.selectionRowMap).reduce((result, key) => {
                    return result.concat(this.selectionRowMap[key] || []);
                }, []);
            },
        },

        methods: {
            __listInit() {
            },
            __formInit() {
            },

            addParam() {
                if (this.echoList.length == 0) {
                    this.$warn('请勾选要添加的用户');
                } else {
                    this.$emit("submitSysUserParam", {
                        "echoList": this.echoList,
                        "echoListName": this.echoListName,
                        'echoListdeptName':this.echoListdeptName,
                        'echoListworkTelnum':this.echoListworkTelnum,
                    });
                    // this.selectionRowMap = {};
                    this.dialogCloseHandler();
                }
            },

            beforeInit() {
                // this.$set(this, 'selectionRowMap', {});
            },
            handleSelectionChange(selecteds, row) {
                if (!this.echoList.includes(row.id)) {
                    this.echoList.push(row.id);  //暂存新勾选的人员Id
                    this.echoListName.push(row.name)
                    this.echoListdeptName.push(row.deptName); 
                    this.echoListworkTelnum.push(row.workTelnum); 
                } else {
                    this.echoList.forEach((id, index) => {
                    if (id == row.id) {
                        this.echoList.splice(index, 1);  //删除暂存的需要取消勾选的人员Id
                        this.echoListName.splice(index, 1);  //删除暂存的需要取消勾选的人员姓名
                        this.echoListdeptName.splice(index, 1)
                        this.echoListworkTelnum.splice(index, 1)
                    }
                    });
                }
            },
            handleAllChange(selecteds) {
            if (selecteds.length > 0) {
                selecteds.forEach(item => {
                if (!this.echoList.includes(item.id)) {
                    this.echoList.push(item.id);  //暂存新勾选的人员Id
                    this.echoListName.push(item.name);  //暂存新勾选的人员姓名
                    this.echoListdeptName.push(item.deptName); 
                    this.echoListworkTelnum.push(item.workTelnum); 
                }
                });
            } else {
                this.page.list.forEach(item => {
                this.echoList.forEach((id, index) => {
                    if (id === item.id) {
                    this.echoList.splice(index, 1);  //删除暂存的需要取消勾选的人员Id
                    this.echoListName.splice(index, 1);  //删除暂存的需要取消勾选的人员姓名
                    this.echoListdeptName.splice(index, 1)
                    this.echoListworkTelnum.splice(index, 1)
                    }
                });
                });
            }
            },
            getQueryParam() {
                return {
                    "name": this.queryFormData.name == undefined ? undefined : this.queryFormData.name,
                    "code": this.queryFormData.code == undefined ? "0123" : this.queryFormData.code,
                    // "corpName":this.queryFormData.corpName == undefined ? "undefined" : this.queryFormData.corpName,
                    "orgType": this.queryFormData.orgType == undefined ? "corp" : this.queryFormData.orgType
                }
            },

            initPageInfo(response) {
                response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.$set(this, 'page', {
                    list: response.records || [],
                    pageNum: response.current || 1,
                    pageSize: response.size || 10,
                    total: response.total || 0
                })
            },

            show(params) {
                this.parentParam = params || {};
                this.name = this.parentParam.name;
                this.readonly = this.parentParam.readonly;
                this.visible = true;
                this.id = this.parentParam.id;
                this.$set(this,'queryFormData',{});
               
                this.$nextTick(function () {
                    this.queryHandler();
                });
            },
            handleCheckChange() {

            },
            resetQueryForms(){
                this.queryFormData.name='';
                this.selectionRowMap = {};
                this.queryHandler();
            }
        },

        watch: {}
    }).form().list('pager').build();
</script>

<style lang="scss">
    .projects-container {
        & > .el-dialog__body {


            height: 400px;
            & > .el-table {
                border: 1px solid #efefef !important;
                border-right: none !important;
                height: 400px;
                /*height: calc(100% - 47px - 15px) !important;*/
            }
        }

        & > .el-dialog__footer {
            & > .footer-wrap {
                & > .el-pagination {
                    float: left;

                    & button {
                        padding: 0 !important;
                    }
                }

                & > .right-wrap {
                    & > span {
                        font-size: 13px;
                        margin-right: 5px;
                        color: #606266;

                        & > strong {
                            color: #333333;
                            margin: 0 2px;
                        }
                    }
                }
            }
        }
    }
</



// WEBPACK FOOTER //
// src/components/sysUserSelect.vue